import { render, staticRenderFns } from "./DepartmentList.vue?vue&type=template&id=3a4bdc3d&scoped=true&"
import script from "./DepartmentList.vue?vue&type=script&lang=js&"
export * from "./DepartmentList.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentList.vue?vue&type=style&index=0&id=3a4bdc3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4bdc3d",
  null
  
)

export default component.exports